module.exports = __webpack_public_path__ + "img/game-features-presets.63a9585c.png";